module.exports = __webpack_public_path__ + "img/tu11.d71152e8.jpg";